import React from 'react';
import PropTypes from 'prop-types';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import './property.scss';

/**
 * PropertyLayout - Common layout for Property Management Portal section
 * @param {Object} props
 * @param {number} props.step - Current step number
 * @param {number} props.totalSteps - Total number of steps
 * @param {string} props.systemId - System ID for the property
 * @param {Function} props.onBackToDashboard - Function to handle back to dashboard navigation
 * @param {boolean} props.hideStepper - Whether to hide the stepper bar
 * @param {React.ReactNode} props.children - Content for the current step
 */
const PropertyLayout = ({ step, totalSteps, systemId, onBackToDashboard, hideStepper = false, children }) => {
  const percent = Math.round((step / totalSteps) * 100);
  const handleCopy = () => {
    if (systemId) {
      navigator.clipboard.writeText(systemId);
    }
  };

  return (
    <div className='property-wrapper'>
      {/* Header Section with Back Button */}
      <div className='property-header-row'>
        {/* Back to Dashboard Button */}
        {onBackToDashboard && (
          <div className='back-to-dashboard'>
            <button
              type='button'
              className='btn-back-dashboard'
              onClick={onBackToDashboard}
              title="Back to Dashboard"
            >
              <ArrowBackIcon />
              Back to Dashboard
            </button>
          </div>
        )}
        {/* Header Content */}
        <div className='property-header'>
          <h1>Property Management Portal</h1>
          <p>Complete property information for listing management</p>
          {systemId && (
            <div className='system-id'>
              <span>{systemId}</span>
              <button type='button' className='btn primary' onClick={handleCopy}>
                Copy
              </button>
            </div>
          )}
        </div>
      </div>
      {/* Stepper */}
      {!hideStepper && (
        <div className='stepper'>
          <span className='step-text'>Step {step} of {totalSteps}</span>
          <div className='step-progress'>
            <div className='step-bar' style={{ width: `${percent}%` }}></div>
          </div>
          <span className='step-percent'>{percent}% Complete</span>
        </div>
      )}
      {/* Step Content */}
      {children}
    </div>
  );
};

PropertyLayout.propTypes = {
  step: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  systemId: PropTypes.string,
  onBackToDashboard: PropTypes.func,
  hideStepper: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default PropertyLayout;
